exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-app{background-color:#eff2f5}.my-app .my-pay .panel{height:1rem;line-height:1rem}.my-app .my-pay .table-row{height:1.5rem;padding:.3rem;border-bottom:none}.my-app .my-pay .mycol{padding-right:.613333rem;text-align:right}.my-app .my-pay .mycol .f-strongest{color:#ff0101}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10a11fe3","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/mypay/Mypay.vue
// module id = 410
// module chunks = 0